import * as React from 'react';
import * as info from "./style.module.scss";
export const Info = () => {
  return (
    <div className={info.info}>
      <div className="container">
        <div className={info.container}>
          <p>При изучении любого иностранного языка больше всего времени занимает запоминание слов.</p>
          <p>За 11 школьных лет большинство людей не запоминают 1000 иностранных слов.</p>
          <p>К сожалению, Вы зубрите новые слова и почти сразу забываете большинство из них. В памяти остаются единицы!</p>
        </div>
      </div>
    </div>
  );
};
